import type { PropsWithChildren } from 'react';
import { useMemo, useState } from 'react';

import { Web3ChainStatusContext } from './context';

export const Web3ChainStatusProvider = ({
  children,
}: PropsWithChildren<{}>) => {
  const [isSwitching, setIsSwitching] = useState(false);

  const contextState = useMemo(
    () => ({ isSwitching, setIsSwitching }),
    [isSwitching],
  );

  return (
    <Web3ChainStatusContext.Provider value={contextState}>
      {children}
    </Web3ChainStatusContext.Provider>
  );
};
